
export const PRIMARY_COLOR = '#D52941'
export const SECONDARY_COLOR = '#2ba5f7'


